import React, { useState } from "react";
import Navbar from "../components/Navbar/Navbar";
import { crmMenu } from "../data/crmMenu";

export const CrmLayout = ({ children, handleShow, showCrmButton }) => {
  return (
    <>
      <Navbar
        menuList={crmMenu}
        Crm={showCrmButton}
        handleShow={handleShow}
        showCrmButton={showCrmButton}
      />
      {children}
    </>
  );
};
